import React from 'react';
import { Grid, Row, Col } from 'react-bootstrap';
import { Button, Image } from 'react-bootstrap';
import LoadingPlaceholder from './../shared/LoadingPlaceholder';
import Summary from './welcome/Summary';
import Login from './shared/Login';
import CardsSlider from './welcome/CardsSlider';
import CustomizeYourStay from './welcome/CustomizeYourStay';
import BestFriend from './shared/BestFriend';
import Weather from './shared/Weather';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getTranslate, getActiveLanguage } from 'react-localize-redux';
import { customerJourneyReservation } from './../../actions';

import './welcome.scss';

const fbChatIcon = require('./../../images/fb_chat.png');

class Welcome extends React.Component {

  constructor(props) {
    super(props);
  }

  componentWillMount() {
    this.props.actions.customerJourneyReservation(this.props.token, this.props.currentLanguage, this.props.context);
  }

  render() {

    const bannerImageStyle = {backgroundImage: `url(${this.props.hotel.picture})`};

    const title = (
      <strong>
        {
          !!this.props.context
          ? this.props.translate('welcome.hello_hotel_context', {hotel: this.props.hotel.name})
          : this.props.translate('welcome.hello', {firstName: this.props.reservation.first_name})
        }
      </strong>
    );
    
    const chatButton = (this.props.reservation.bot || {}).enabled
      ? <Button className="welcome-component__fb-chat-button" href={(this.props.reservation.bot || {}).link} target="_blank" bsSize="sm">
          <Image src={fbChatIcon} rounded height={20}/> {this.props.translate('welcome.fb_chat_button')}
        </Button>
      : null ;

    return (
      <Grid className="welcome-component">
        
        <Row>

          { /* For large Devices */ }
          <Col sm={8} xsHidden>
            <h1>
              <LoadingPlaceholder ready={!this.props.loading} text-align="left">
                { title } { chatButton }
              </LoadingPlaceholder>
            </h1>
          </Col>
          <Col sm={4} xsHidden>
            <h3 className="text-right">
              <LoadingPlaceholder ready={!this.props.loading}>
              {
                  !!this.props.context ?
                  (<span>Login</span>) :
                  (
                    <span>{this.props.translate('welcome.here_your_reservation')}<br/>
                    <strong>@{this.props.hotel.name}</strong></span>
                  )
              }
              </LoadingPlaceholder>
            </h3>
          </Col>

          { /* For small Devices */ }
          <Col xs={12} className="text-center" lgHidden mdHidden smHidden>
            <h1>
              <LoadingPlaceholder ready={!this.props.loading} text-align="left">
                { title }
              </LoadingPlaceholder>
            </h1>
          </Col>
          <Col xs={12} className="text-center" lgHidden mdHidden smHidden>
            <LoadingPlaceholder ready={!this.props.loading} text-align="left">
              { chatButton }
            </LoadingPlaceholder>
          </Col>
          <Col xs={12} lgHidden mdHidden smHidden>
            <h3 className="text-center">
              <LoadingPlaceholder ready={!this.props.loading}>
              {
                  !!this.props.context ?
                  (<span>Login</span>) :
                  (
                    <span>{this.props.translate('welcome.here_your_reservation')}<br/>
                    <strong>@{this.props.hotel.name}</strong></span>
                  )
              }
              </LoadingPlaceholder>
            </h3>
          </Col>
        </Row>

        <Row className="welcome-banner">
          <Col xs={12}>
            <div className="welcome-banner__image-holder" style={bannerImageStyle}>

              <div className="welcome-banner__overlay"></div>

              <Col xs={12} sm={8}>
                <div className="welcome-banner__text-holder">
                  <div>
                    <h4>{this.props.hotel.text}</h4>
                    <h6 className="text-right"><i>{this.props.hotel.signature}</i> <strong>{this.props.hotel.role}</strong></h6>
                  </div>
                </div>
              </Col>

              <Col xs={12} sm={4} className="welcome-banner__reservation-summary-wrap">
                <Row>
                  <Col xs={12}>
                    {!!this.props.context || this.props.hotel.customer_journey_status != 'active' ? <Login/> : <Summary/>}
                  </Col>
                </Row>
              </Col>

            </div>
          </Col>
        </Row>

        <CardsSlider />
        <br/>

        <CustomizeYourStay />
        <br/>

        <BestFriend/>
        <br/>

        <Weather/>
        <br/>
        
      </Grid>
    );
  }
}

Welcome.displayName = 'PagesWelcome';
Welcome.propTypes = {};
Welcome.defaultProps = {};

const mapStateToProps = (state) => {
  return { 
      translate: getTranslate(state.locale),
      currentLanguage: getActiveLanguage(state.locale).code,
      token: state.commons.token,
      context: state.commons.context,
      hotel: state.hotel.apiData,
      reservation: state.reservation.apiData,
      loading: state.hotel.loading || state.reservation.loading
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: {
      customerJourneyReservation: bindActionCreators(customerJourneyReservation, dispatch)
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Welcome);



// WEBPACK FOOTER //
// ./components/pages/Welcome.js